export const colorPalettes = {
    text: {
        FOUR_SG: {
            light: '#fff',
            dark: '#730f19',
        },
        FUND: {
            light: '#02d1d1',
            dark: '#0000FE',
        },
    },
}